var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from "react";
import { Tree, Input, Button, Typography, Empty, Dropdown, Menu, Tooltip, } from "antd";
import { EllipsisOutlined, CaretRightOutlined, CaretDownOutlined, EditOutlined, DeleteOutlined, } from "@ant-design/icons";
var Search = Input.Search;
var Text = Typography.Text;
// 修改全局样式，添加调整间距的CSS
// 修改全局样式，调整箭头方向
var globalStyles = "\n  .comps-tree .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-treenode {\n    width: 100% !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n\n  /* \u9690\u85CF antd \u81EA\u5E26\u7684\u62D6\u62FD\u5C0F\u56FE\u6807\uFF0C\u53EA\u4FDD\u7559\u4E1A\u52A1\u56FE\u6807 */\n  .comps-tree .ant-tree-draggable-icon {\n    display: none !important;\n  }\n  \n  .comps-tree .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-node-content-wrapper {\n    width: 100% !important;\n    display: flex !important;\n    align-items: center !important;\n    padding: 0 4px !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n  \n  /* \u786E\u4FDD\u81EA\u5B9A\u4E49\u56FE\u6807\u53EF\u89C1\u5E76\u7559\u51FA\u95F4\u8DDD */\n  .comps-tree .ant-tree-icon__customize {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin-right: 6px !important;\n  }\n  \n  .comps-tree .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-title {\n    width: 100% !important;\n    min-width: 0 !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* \u6587\u5B57\u533A\u57DF\uFF1A\u5360\u636E\u5269\u4F59\u7A7A\u95F4 */\n  .comps-tree .ant-tree-title > div:first-child {\n    min-width: 0 !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* \u786E\u4FDD\u6587\u672C\u5185\u5BB9\u6B63\u786E\u622A\u65AD */\n  .comps-tree .ant-tree-title > div:first-child > span,\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip,\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip > span,\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip-wrapper,\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip-wrapper > span {\n    display: block !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    white-space: nowrap !important;\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* \u786E\u4FDD Tooltip \u5305\u88C5\u5668\u4E0D\u4F1A\u5F71\u54CD\u5E03\u5C40 */\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip,\n  .comps-tree .ant-tree-title > div:first-child > .ant-tooltip-wrapper {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n    display: block !important;\n  }\n  \n  /* \u56FE\u6807\u533A\u57DF\uFF1A\u72EC\u7ACB\u533A\u57DF\uFF0C\u4E0D\u6536\u7F29 */\n  .comps-tree .ant-tree-title > div:last-child {\n    flex-shrink: 0 !important;\n    overflow: visible !important;\n  }\n\n  /* \u65B9\u6CD5\u5FBD\u6807\u6837\u5F0F\uFF08\u7528\u4E8E\u63A5\u53E3\u8282\u70B9\u524D\u7F00\uFF09 */\n  .api-method-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 36px;\n    height: 18px;\n    padding: 0 6px;\n    font-size: 10px;\n    font-weight: 700;\n    border-radius: 4px;\n    margin-right: 6px;\n    border: 1px solid transparent;\n  }\n  \n  .comps-tree .ant-tree-switcher .anticon {\n    color: #bfbfbf !important;\n  }\n  \n  .comps-tree .ant-tree-switcher {\n    padding: 0 2px !important;\n    width: 18px !important;\n  }\n  \n  .comps-tree .tree-node-add-button {\n    color: #bfbfbf !important;\n  }\n  \n  .comps-tree .tree-node-add-button:hover {\n    color: #1890ff !important;\n  }\n  \n  .compact-tree .ant-tree-treenode {\n    padding: 0 !important;\n  }\n  \n  /* \u7D27\u51D1\u6A21\u5F0F\u6837\u5F0F - 24px \u884C\u9AD8 */\n  .comps-tree.compact .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-treenode {\n    height: 24px !important;\n    line-height: 24px !important;\n  }\n  \n  .comps-tree.compact .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-node-content-wrapper {\n    height: 24px !important;\n    line-height: 24px !important;\n  }\n  \n  .comps-tree .ant-tree {\n    width: 100% !important;\n  }\n  \n  .comps-tree .ant-tree .ant-tree-list {\n    width: 100% !important;\n  }\n  \n  .comps-tree .ant-tree .ant-tree-list .ant-tree-list-holder {\n    width: 100% !important;\n  }\n";
/**
 * 通用树组件（内核）
 * 只包含树核心功能，不包含容器和标题栏
 */
var CompsTree = function (_a) {
    var _b = _a.treeData, treeData = _b === void 0 ? [] : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, onSelect = _a.onSelect, onMenuClick = _a.onMenuClick, onDoubleClick = _a.onDoubleClick, _d = _a.checkable, checkable = _d === void 0 ? false : _d, checkedKeys = _a.checkedKeys, onCheck = _a.onCheck, _e = _a.showSearch, showSearch = _e === void 0 ? true : _e, _f = _a.showLine, showLine = _f === void 0 ? true : _f, _g = _a.showIcon, showIcon = _g === void 0 ? false : _g, _h = _a.defaultExpandAll, defaultExpandAll = _h === void 0 ? true : _h, _j = _a.defaultExpandedKeys, defaultExpandedKeys = _j === void 0 ? [] : _j, _k = _a.defaultSelectedKeys, defaultSelectedKeys = _k === void 0 ? [] : _k, _l = _a.menuItems, menuItems = _l === void 0 ? [] : _l, switcherIcon = _a.switcherIcon, selectedKeys = _a.selectedKeys, expandedKeys = _a.expandedKeys, onExpand = _a.onExpand, _m = _a.showActions, showActions = _m === void 0 ? true : _m, onEdit = _a.onEdit, onDelete = _a.onDelete, customMenuButton = _a.customMenuButton, className = _a.className, style = _a.style, _o = _a.compact, compact = _o === void 0 ? false : _o, height = _a.height, treeScrollHeight = _a.treeScrollHeight, _p = _a.searchPlaceholder, searchPlaceholder = _p === void 0 ? "搜索..." : _p, _q = _a.draggable, draggable = _q === void 0 ? false : _q, onTreeDataChange = _a.onTreeDataChange;
    // 状态定义
    var _r = useState(""), searchValue = _r[0], setSearchValue = _r[1];
    var _s = useState(defaultExpandedKeys), internalExpandedKeys = _s[0], setInternalExpandedKeys = _s[1];
    var _t = useState(true), autoExpandParent = _t[0], setAutoExpandParent = _t[1];
    var _u = useState(treeData), filteredTreeData = _u[0], setFilteredTreeData = _u[1];
    var containerRef = useRef(null);
    var treeContainerRef = useRef(null);
    var _v = useState(0), containerWidth = _v[0], setContainerWidth = _v[1]; // 容器宽度
    var _w = useState(0), treeContainerHeight = _w[0], setTreeContainerHeight = _w[1]; // 树区域高度，传给 Tree 的 height 以启用内部滚动
    // 使用外部expandedKeys或内部状态
    var currentExpandedKeys = expandedKeys || internalExpandedKeys;
    // 监听树容器高度变化，用于传给 rc-tree height 以启用内部滚动
    useEffect(function () {
        var el = treeContainerRef.current;
        if (!el)
            return;
        var updateHeight = function () {
            var h = el.clientHeight || el.offsetHeight;
            setTreeContainerHeight(Math.max(0, h));
        };
        updateHeight();
        var ro = new ResizeObserver(updateHeight);
        ro.observe(el);
        return function () { return ro.disconnect(); };
    }, [filteredTreeData.length]); // 有数据时树容器才渲染，需重测
    // 监听容器宽度变化
    useEffect(function () {
        var updateWidth = function () {
            if (containerRef.current) {
                var width = containerRef.current.offsetWidth;
                setContainerWidth(width);
            }
        };
        // 初始设置
        updateWidth();
        // 监听窗口大小变化
        var resizeObserver = new ResizeObserver(function () {
            updateWidth();
        });
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }
        return function () {
            resizeObserver.disconnect();
        };
    }, []);
    // 过滤树数据
    var filterTree = React.useCallback(function (value) {
        var expandKeys = [];
        // 安全获取用于搜索的文本（title 可能为 ReactNode）
        var getNodeSearchText = function (node) {
            var parts = [];
            if (typeof (node === null || node === void 0 ? void 0 : node.title) === "string")
                parts.push(node.title);
            if (typeof (node === null || node === void 0 ? void 0 : node.serviceName) === "string")
                parts.push(node.serviceName);
            var p = (node === null || node === void 0 ? void 0 : node.permission) || (node === null || node === void 0 ? void 0 : node.permissionData);
            if (p) {
                if (typeof p.code === "string")
                    parts.push(p.code);
                if (typeof p.page === "string")
                    parts.push(p.page);
                if (typeof p.title === "string")
                    parts.push(p.title);
                if (typeof p.name === "string")
                    parts.push(p.name);
            }
            return parts.join(" ").toLowerCase();
        };
        // 递归查找匹配节点及其父节点
        var filterData = function (data) {
            return data
                .map(function (node) {
                var matchNode = getNodeSearchText(node).includes(value.toLowerCase());
                // 处理子节点
                var children = node.children ? filterData(node.children) : [];
                var matchChildren = children.length > 0;
                // 如果自身匹配或有匹配的子节点，则保留节点
                if (matchNode || matchChildren) {
                    expandKeys.push(node.key);
                    return __assign(__assign({}, node), { children: children.length > 0 ? children : undefined });
                }
                return null;
            })
                .filter(function (node) { return node !== null; });
        };
        var filtered = filterData(treeData);
        setFilteredTreeData(filtered);
        if (!expandedKeys) {
            setInternalExpandedKeys(expandKeys);
        }
        setAutoExpandParent(true);
    }, [treeData, expandedKeys]);
    // 当原始树数据变化时，更新过滤后的树数据
    useEffect(function () {
        if (searchValue) {
            filterTree(searchValue);
        }
        else {
            setFilteredTreeData(treeData);
        }
    }, [treeData, searchValue, filterTree]);
    // 当外部expandedKeys变化时，同步到内部状态
    useEffect(function () {
        if (expandedKeys) {
            setInternalExpandedKeys(expandedKeys);
        }
    }, [expandedKeys]);
    // 添加这个新的 useEffect 以处理 defaultExpandAll
    useEffect(function () {
        if (defaultExpandAll && treeData.length > 0 && !expandedKeys) {
            // 收集所有节点的 key
            var getAllKeys_1 = function (nodes) {
                var keys = [];
                nodes.forEach(function (node) {
                    keys.push(node.key);
                    if (node.children && node.children.length > 0) {
                        keys = __spreadArray(__spreadArray([], keys, true), getAllKeys_1(node.children), true);
                    }
                });
                return keys;
            };
            var allKeys = getAllKeys_1(treeData);
            setInternalExpandedKeys(allKeys);
            setAutoExpandParent(true);
        }
    }, [treeData, defaultExpandAll, expandedKeys]);
    // 处理搜索
    var handleSearch = function (value) {
        setSearchValue(value);
        if (value) {
            filterTree(value);
        }
        else {
            setFilteredTreeData(treeData);
            if (!expandedKeys) {
                setInternalExpandedKeys(defaultExpandedKeys);
            }
        }
    };
    // 处理展开/折叠
    var handleExpand = function (newExpandedKeys, info) {
        if (onExpand) {
            // 如果有外部onExpand处理器，调用它
            onExpand(newExpandedKeys, info);
        }
        else {
            // 否则使用内部状态
            setInternalExpandedKeys(newExpandedKeys);
        }
        setAutoExpandParent(false);
    };
    // 渲染树节点标题，包括操作按钮
    var renderNodeTitle = function (node, level) {
        var _a, _b;
        if (level === void 0) { level = 0; }
        // 使用节点自己的菜单项，如果没有则使用全局菜单项
        var nodeMenuItems = node.menuItems || menuItems || [];
        // 如果是接口节点，构建方法徽标
        var method = (((_a = node.apiData) === null || _a === void 0 ? void 0 : _a.method) || ((_b = node.apiData) === null || _b === void 0 ? void 0 : _b.httpMethod) || "")
            .toString()
            .toUpperCase();
        var paletteMap = {
            GET: { bg: "#f6ffed", fg: "#52c41a", border: "#52c41a20" },
            POST: { bg: "#e6f4ff", fg: "#1677ff", border: "#1677ff20" },
            PUT: { bg: "#fff7e6", fg: "#fa8c16", border: "#fa8c1620" },
            PATCH: { bg: "#f9f0ff", fg: "#722ed1", border: "#722ed120" },
            DELETE: { bg: "#fff1f0", fg: "#ff4d4f", border: "#ff4d4f20" },
        };
        var palette = paletteMap[method] || {
            bg: "#f0f0f0",
            fg: "#999",
            border: "#99999920",
        };
        var menu = (_jsx(Menu, __assign({ onClick: function (_a) {
                var key = _a.key;
                onMenuClick && onMenuClick(node, key);
            } }, { children: nodeMenuItems.map(function (item) { return (_jsx(Menu.Item, { children: item.label }, item.key)); }) })));
        // 获取节点标题文本（用于 Tooltip）
        var titleText = typeof node.title === "string" ? node.title : String(node.title);
        // 计算右侧图标区域需要的宽度（预留空间）
        var iconAreaWidth = 8; // marginLeft
        if (showActions && onEdit)
            iconAreaWidth += 24; // 编辑按钮
        if (showActions && onDelete)
            iconAreaWidth += 24; // 删除按钮
        if (customMenuButton) {
            var customWidth = typeof (node === null || node === void 0 ? void 0 : node.customMenuButtonWidth) === "number"
                ? node.customMenuButtonWidth
                : 24;
            iconAreaWidth += customWidth; // 自定义按钮（可配置宽度）
        }
        else if (!customMenuButton &&
            onMenuClick &&
            nodeMenuItems &&
            nodeMenuItems.length > 0) {
            iconAreaWidth += 24; // 更多操作按钮
        }
        // 如果有多个按钮，需要加上 gap
        var buttonCount = [
            showActions && onEdit,
            showActions && onDelete,
            customMenuButton ||
                (!customMenuButton &&
                    onMenuClick &&
                    nodeMenuItems &&
                    nodeMenuItems.length > 0),
        ].filter(Boolean).length;
        if (buttonCount > 1) {
            iconAreaWidth += (buttonCount - 1) * 8; // gap 间距
        }
        return (_jsxs("div", __assign({ style: {
                display: "grid",
                gridTemplateColumns: "1fr ".concat(iconAreaWidth, "px"),
                alignItems: "center",
                width: "100%",
                minWidth: 0,
                overflow: "hidden",
                gap: "8px",
            } }, { children: [_jsx("div", __assign({ style: {
                        minWidth: 0,
                        overflow: "hidden",
                    } }, { children: _jsx(Tooltip, __assign({ title: titleText, placement: "right", mouseEnterDelay: 0.5, overlayStyle: { maxWidth: "400px" } }, { children: _jsx("span", __assign({ style: {
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                width: "100%",
                                minWidth: 0,
                            } }, { children: node.title })) })) })), _jsxs("div", __assign({ style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: "8px",
                        minWidth: "".concat(iconAreaWidth, "px"),
                        width: "".concat(iconAreaWidth, "px"),
                        flexShrink: 0,
                    } }, { children: [showActions && onEdit && (_jsx(Button, { type: "text", icon: _jsx(EditOutlined, {}), size: "small", onClick: function (e) {
                                e.stopPropagation();
                                onEdit(node);
                            }, style: {
                                padding: "0 4px",
                                color: "#bfbfbf",
                                fontSize: "12px",
                            }, title: "\u7F16\u8F91" })), showActions && onDelete && (_jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), size: "small", onClick: function (e) {
                                e.stopPropagation();
                                onDelete(node);
                            }, style: {
                                padding: "0 4px",
                                color: "#bfbfbf",
                                fontSize: "12px",
                            }, title: "\u5220\u9664" })), customMenuButton && customMenuButton(node), !customMenuButton &&
                            onMenuClick &&
                            nodeMenuItems &&
                            nodeMenuItems.length > 0 && (_jsx(Dropdown, __assign({ overlay: menu, trigger: ["click"] }, { children: _jsx(Button, { type: "text", icon: _jsx(EllipsisOutlined, {}), size: "small", onClick: function (e) { return e.stopPropagation(); }, style: {
                                    padding: "0 4px",
                                    color: "#bfbfbf",
                                    fontSize: "12px",
                                }, className: "tree-node-add-button", title: "\u66F4\u591A\u64CD\u4F5C" }) })))] }))] })));
    };
    // 添加自定义标题到树数据
    var addCustomTitleToData = function (data, level) {
        if (level === void 0) { level = 0; }
        return data.map(function (node) {
            var newNode = __assign(__assign({}, node), { title: renderNodeTitle(node, level) });
            if (node.children) {
                newNode.children = addCustomTitleToData(node.children, level + 1);
            }
            return newNode;
        });
    };
    // 带自定义标题的树数据
    var treeDataWithCustomTitle = addCustomTitleToData(filteredTreeData);
    // 处理拖拽排序（仅移动节点引用，不深拷贝，避免丢失 title/service 导致白屏）
    var handleDrop = function (info) {
        if (!draggable || !(filteredTreeData === null || filteredTreeData === void 0 ? void 0 : filteredTreeData.length)) {
            return;
        }
        var dropKey = info.node.key;
        var dragKey = info.dragNode.key;
        var dropPos = info.node.pos.split("-");
        var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        var findParentAndIndex = function (arr, key) {
            for (var i = 0; i < arr.length; i += 1) {
                if (arr[i].key === key)
                    return { parentArr: arr, index: i };
                var ch = arr[i].children;
                if (ch === null || ch === void 0 ? void 0 : ch.length) {
                    var found = findParentAndIndex(ch, key);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        // 浅拷贝结构、保留节点引用（title/service 等不丢失）
        var newTree = (filteredTreeData || []).map(function (g) { return (__assign(__assign({}, g), { children: g.children ? __spreadArray([], g.children, true) : [] })); });
        var dragLoc = findParentAndIndex(newTree, dragKey);
        if (!dragLoc)
            return;
        var dragObj = dragLoc.parentArr[dragLoc.index];
        dragLoc.parentArr.splice(dragLoc.index, 1);
        var dropLoc = findParentAndIndex(newTree, dropKey);
        if (!dropLoc)
            return;
        if (!info.dropToGap) {
            var dropNode = dropLoc.parentArr[dropLoc.index];
            var children = dropNode.children ? __spreadArray([], dropNode.children, true) : [];
            children.push(dragObj);
            dropNode.children = children;
        }
        else if ((info.node.children && info.node.children.length > 0 && info.node.expanded) &&
            dropPosition === 1) {
            var dropNode = dropLoc.parentArr[dropLoc.index];
            var children = dropNode.children ? __spreadArray([], dropNode.children, true) : [];
            children.unshift(dragObj);
            dropNode.children = children;
        }
        else {
            // 同层级插入：若在同一父节点且已先移除拖拽项，需修正插入下标
            var insertIdx = void 0;
            if (dragLoc.parentArr === dropLoc.parentArr && dropLoc.index >= dragLoc.index) {
                var newDropIdx = dropLoc.index - 1;
                insertIdx = dropPosition === -1 ? newDropIdx : newDropIdx + 1;
            }
            else {
                insertIdx = dropPosition === -1 ? dropLoc.index : dropLoc.index + 1;
            }
            dropLoc.parentArr.splice(insertIdx, 0, dragObj);
        }
        setFilteredTreeData(newTree);
        onTreeDataChange === null || onTreeDataChange === void 0 ? void 0 : onTreeDataChange(newTree);
    };
    // 增强 switcherIconFunc 函数
    var switcherIconFunc = function (props) {
        var expanded = !!props.expanded;
        // 添加内联样式，确保不会被其他样式覆盖
        var iconStyle = {
            color: "#bfbfbf",
            transform: "none !important",
            transition: "none !important",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
        };
        if (expanded) {
            // 向下箭头 - 使用内置图标
            return _jsx(CaretDownOutlined, { style: iconStyle });
        }
        else {
            // 向右箭头 - 使用内置图标
            return _jsx(CaretRightOutlined, { style: iconStyle });
        }
    };
    /**
     * 高度与内部层级（供充满上级空间时参考）：
     * - 根容器：flex 列，height 为 props.height 或 "100%"，overflow: hidden；height="100%" 时加 flex:1 minHeight:0 以便在 flex 父节点下获得明确高度，使内部 .tree-container 可滚动
     * - 搜索区（若有）：flexShrink: 0，不参与高度分配
     * - 树区域 .tree-container：flex: 1, minHeight: 0, overflow: auto，负责内部滚动
     */
    var isFullHeight = height === "100%";
    var containerStyle = __assign(__assign(__assign({ display: "flex", flexDirection: "column", height: height
            ? typeof height === "number"
                ? "".concat(height, "px")
                : height
            : "100%" }, (isFullHeight && { flex: 1, minHeight: 0 })), { overflow: "hidden" }), style);
    var treeContainerStyle = {
        flex: 1,
        minHeight: 0,
        height: "100%",
        overflow: "auto",
        marginTop: "0",
        padding: "0",
    };
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: globalStyles }), _jsxs("div", __assign({ ref: containerRef, className: "comps-tree ".concat(compact ? "compact" : "", " ").concat(className || ""), style: containerStyle }, { children: [showSearch && (_jsx("div", __assign({ className: "tree-search-container", style: {
                            flexShrink: 0,
                            marginBottom: "16px",
                        } }, { children: _jsx(Search, { placeholder: searchPlaceholder, allowClear: true, onChange: function (e) {
                                return handleSearch(e.target.value);
                            } }) }))), filteredTreeData.length > 0 ? (_jsx("div", __assign({ ref: treeContainerRef, className: "tree-container", style: treeContainerStyle }, { children: _jsx(Tree, { className: "full-width-tree compact-tree", checkable: checkable, showLine: false, showIcon: showIcon, draggable: draggable, height: treeScrollHeight !== null && treeScrollHeight !== void 0 ? treeScrollHeight : (height === "100%"
                                ? undefined
                                : treeContainerHeight > 0
                                    ? treeContainerHeight
                                    : undefined), onExpand: handleExpand, expandedKeys: currentExpandedKeys, autoExpandParent: autoExpandParent, onSelect: onSelect, onDoubleClick: onDoubleClick, onDrop: handleDrop, onCheck: function (keys, info) {
                                if (onCheck) {
                                    var normalized = Array.isArray(keys)
                                        ? keys
                                        : keys.checked;
                                    onCheck(normalized, info);
                                }
                            }, checkedKeys: checkedKeys, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, defaultExpandAll: defaultExpandAll, treeData: treeDataWithCustomTitle, switcherIcon: switcherIconFunc, style: {
                                width: "100%",
                                height: height === "100%" ? "100%" : undefined,
                                fontSize: "14px",
                            } }) }))) : (_jsx("div", __assign({ style: {
                            flex: 1,
                            minHeight: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } }, { children: _jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" }) })))] }))] }));
};
export default CompsTree;
